import {pick} from 'helpers';

export function subTasks(task) {
  return {
    ...pick(task, 'name', 'orderIndex', 'parentId', 'parentStatusId', 'status', 'time'),
    serverId: task.id,
  }
}
